<template>
  <div class="layout">
    <div class="container">
      <gc-header-toolbar
        :menu-toggle-enabled="headerMenuTogglerEnabled"
        :toggle-menu-func="toggleMenu"
        :baseView="baseView"
        :selectedIndex="selectedIndex"
        :tabs="tabs"
        :isXSmall="isXSmall"
        :isLarge="isLarge"
        :back-button-enabled="true"
        :backButtonFunc="backButtonFunction"
        :profile-menu-enabled="true"
      >
        <template v-slot:headerContent="slotProps">
          <slot name="headerContent" :baseView="slotProps.baseView" />
        </template>
      </gc-header-toolbar>

      <dx-scroll-view ref="scrollViewRef" class="layout-body with-footer">
        <div class="content">
          <slot />
          <GcPopupValidationSummary
            v-if="formsConfig"
            :showPopup.sync="formsConfig.validationSummaryVisible"
            :validation-group="formsConfig.validationGroup"
            :title="'Validation Errors'"
            :isXSmall="isXSmall"
            :items.sync="formsConfig.items"
          ></GcPopupValidationSummary>
          <GcPopupValidationSummary
            v-if="formsConfig"
            :showPopup.sync="formsConfig.serverValidationSummaryVisible"
            :title="'Server Error'"
            :isXSmall="isXSmall"
            :items.sync="formsConfig.serverItems"
          ></GcPopupValidationSummary>
          <DxLoadPanel
            v-if="formsConfig"
            :position="loadingPosition"
            :visible.sync="formsConfig.loadingVisible"
            :show-indicator="true"
            :show-pane="true"
            :shading="true"
            :hide-on-outside-click="false"
            shading-color="rgba(0,0,0,0)"
          />
          <GcPopupAlert
            v-if="formsConfig"
            :showPopupAlert.sync="formsConfig.popupAlertVisible"
            :title="''"
            :isXSmall="isXSmall"
            :message.sync="formsConfig.popupAlertMessage"
            @send-message="handleSendMessage"
          ></GcPopupAlert>
        </div>
      </dx-scroll-view>
      <div class="gc-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
// import "../assets/styles/global.scss";
import { NavigationStorage } from "../../_services/storage";
import { mapGetters } from "vuex";

function removeIconProperty(obj) {
  for (let prop in obj) {
    if (prop === "icon") delete obj[prop];
    else if (typeof obj[prop] === "object") removeIconProperty(obj[prop]);
  }
}

export default {
  props: {
    title: String,
    isXSmall: Boolean,
    isLarge: Boolean,
    selectedIndex: Number,
    baseView: Object,
    tabs: {
      type: Array,
      default: function() {
        return [];
      },
    },
    formsConfig: {
      type: Object,
      default: function() {
        return null;
      },
    },
    backButtonFunction: {
      type: Function,
      default: function() {
        alert("Chumma Default");
      },
    },
  },
  beforeMount() {
    let globalCss = document.querySelector("#global-css");
    globalCss.setAttribute("media", "");

    let salesCss = document.querySelector("#sales-css");
    salesCss.setAttribute("media", "");
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleSendMessage(value) {
      // eslint-disable-next-line no-console
      // this.$logger.debug("parent handleSendMessage", value);
    },
    closePopupAlert() {
      this.$emit("update:showPopupAlert", false);
      this.$emit("update:message", "");
    },
    toggleMenu(e) {
      const pointerEvent = e.event;
      pointerEvent.stopPropagation();
      if (this.menuOpened) {
        this.menuTemporaryOpened = false;
      }
      this.menuOpened = !this.menuOpened;
    },
    handleSideBarClick() {
      if (this.menuOpened === false) this.menuTemporaryOpened = true;
      this.menuOpened = true;
    },
  },
  data() {
    return {
      menuOpened: this.isLarge,
      menuTemporaryOpened: false,
      menuItemsToFilter: [],
      loadingPosition: { of: "#container-wrapper" },
    };
  },
  created() {
    this.menuItemsToFilter = NavigationStorage.getItems();
  },
  computed: {
    ...mapGetters({ applicationMode: "profile/applicationMode" }),
    drawerOptions() {
      const shaderEnabled = !this.isLarge;
      return {
        menuMode: this.isLarge ? "shrink" : "overlap",
        menuRevealMode: this.isXSmall ? "slide" : "expand",
        minMenuSize: this.isXSmall ? 0 : 60,
        menuOpened: this.isLarge,
        hideOnOutsideClick: shaderEnabled,
        shaderEnabled,
      };
    },
    headerMenuTogglerEnabled() {
      return false;
    },
    scrollView() {
      return this.$refs["scrollViewRef"].instance;
    },
    menuItems() {
      // eslint-disable-next-line no-console
      // this.$logger.debug("isXSmall", this.isXSmall);

      if (this.isXSmall === true) {
        removeIconProperty(this.menuItemsToFilter);
      }
      return this.menuItemsToFilter;
    },
  },
  watch: {
    isLarge() {
      if (!this.menuTemporaryOpened) {
        this.menuOpened = this.isLarge;
      }
    },
    isXSmall(value) {
      if (value)
        this.$store.dispatch("profile/setApplicationMode", "GcorpRoam");
      else this.$store.dispatch("profile/setApplicationMode", "Gcorp");
    },
    $route() {
      if (this.menuTemporaryOpened || !this.isLarge) {
        this.menuOpened = false;
        this.menuTemporaryOpened = false;
      }
      this.scrollView.scrollTo(0);
    },
    applicationMode(mode) {
      this.$logger.info(`Application Mode:  ${mode}`);
      this.menuItemsToFilter = NavigationStorage.getItems();
      // eslint-disable-next-line no-console
      // this.$logger.debug(this.menuItemsToFilter);
    },
  },
  components: {},
};
</script>

<style lang="scss">
.layout {
  width: 100%;
}

.container {
  height: 100%;
  flex-direction: column;
  display: flex;
}

.layout-body {
  flex: 1;
  min-height: 0;
}

.content {
  flex-grow: 1;
}

#navigation-header {
  @import "../../assets/styles/variables.additional.scss";
  background-color: $base-accent;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .menu-button .dx-icon {
    color: $base-text-color;
  }

  .screen-x-small & {
    padding-left: 10px;
  }

  .dx-theme-generic & {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.layout-body .dx-scrollview-content .content .view-toolbar .dx-toolbar-before {
  padding-left: 30px;
}
</style>
